import React from "react";
import { Box, Button, HStack, Heading, Icon, Input, Select, VStack, useToast, InputGroup, InputLeftElement, Stat, StatLabel, StatNumber, StatHelpText, Badge, Avatar, AvatarGroup, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useDisclosure, Text, RangeSlider, RangeSliderTrack, RangeSliderFilledTrack, RangeSliderThumb, FormControl, FormLabel } from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiPlus, FiTrash2, FiCheckSquare } from "react-icons/fi";
import { listForms, removeForm, listTechnicians, addForm, clearForms, addTechnician, submitSurvey } from "../../../utils/formsApi";
import ModernTable, { TABLE_ACTIONS } from "../../../components/tables/ModernTable";
import * as XLSX from "xlsx";

export default function FormsLite() {
  const [items, setItems] = React.useState([]);
  const [customerName, setCustomerName] = React.useState("");
  const [serialNumber, setSerialNumber] = React.useState("");
  const [search, setSearch] = React.useState("");
  const [dateFrom, setDateFrom] = React.useState("");
  const [dateTo, setDateTo] = React.useState("");
  const [followFilter, setFollowFilter] = React.useState("all");
  const [deliveredFilter, setDeliveredFilter] = React.useState("all");
  const [techFilter, setTechFilter] = React.useState("all");
  const [payFilter, setPayFilter] = React.useState("all");
  const [opFilter, setOpFilter] = React.useState("all");
  const [surveyFilter, setSurveyFilter] = React.useState("all");
  const [techs, setTechs] = React.useState([]);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Survey random ranges
  const [ranges, setRanges] = React.useState({
    q1: [4, 5], // Hizmet memnuniyeti
    q2: [4, 5], // Teknisyen iletişimi
    q3: [3, 5], // Zamanında gelme
    q4: [4, 5], // Çözüm yeterliliği
  });

  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  const reload = React.useCallback(async () => {
    const rows = await listForms();
    setItems(rows);
  }, []);

  React.useEffect(() => { reload(); }, [reload]);
  React.useEffect(() => {
    const params = new URLSearchParams(location.search || "");
    const pay = params.get("pay");
    if (pay === "paid" || pay === "unpaid") {
      setPayFilter(pay);
    }
  }, [location.search]);
  React.useEffect(() => {
    let ws; let es;
    try {
      const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
      const host = window.location.host;
      ws = new WebSocket(`${proto}://${host}/ws/dashboard/`);
      ws.onmessage = (evt) => {
        try {
          const msg = JSON.parse(evt.data || "{}");
          if (msg && msg.resource === "service_forms") {
            reload();
          }
        } catch (_) { }
      };
      ws.onerror = () => {
        try { ws && ws.close(); } catch (_) { }
        try {
          es = new EventSource("/events/");
          es.onmessage = (evt) => {
            try {
              const msg = JSON.parse((evt && evt.data) || "{}");
              if (msg && msg.resource === "service_forms") {
                reload();
              }
            } catch (_) { }
          };
        } catch (_) { }
      };
    } catch (_) { }
    return () => { try { ws && ws.close(); } catch (_) { }; try { es && es.close(); } catch (_) { } };
  }, [reload]);
  React.useEffect(() => {
    let alive = true;
    (async () => {
      const t = await listTechnicians();
      if (!alive) return;
      setTechs(t);
    })();
    return () => { alive = false; };
  }, []);

  const handleAdd = async () => {
    if (!customerName || !serialNumber) {
      toast({ title: "Müşteri ve seri no zorunlu", status: "warning" });
      return;
    }
    await addForm({
      serial_number: serialNumber,
      customer_name: customerName,
    });
    setCustomerName("");
    setSerialNumber("");
    toast({ title: "Form kaydedildi", status: "success" });
    reload();
  };

  const handleDelete = async (id) => {
    await removeForm(id);
    toast({ title: "Silindi", status: "info" });
    reload();
  };

  const handleExportJson = async () => {
    try {
      const data = items;
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `service_forms_${new Date().toISOString().split("T")[0]}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast({ title: "JSON dışa aktarıldı", status: "success" });
    } catch (e) {
      toast({ title: "Dışa aktarma hatası", description: String(e.message || e), status: "error" });
    }
  };

  const handleImportJson = async (file) => {
    if (!file) return;
    try {
      const text = await file.text();
      const payload = JSON.parse(text);
      const techs = await listTechnicians();
      const techByName = new Map(techs.map(t => [String(t.name || "").trim().toLowerCase(), t.id]));
      const techById = new Map(techs.map(t => [String(t.id), t]));
      const toISODate = (s) => {
        if (!s) return null;
        const t = String(s).trim();
        const m = t.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{4})$/);
        if (m) {
          const d = m[1].padStart(2, '0');
          const mo = m[2].padStart(2, '0');
          const y = m[3];
          return `${y}-${mo}-${d}`;
        }
        const d = new Date(t);
        if (!isNaN(d.getTime())) return d.toISOString().split('T')[0];
        return null;
      };
      const toISOTime = (s) => {
        if (!s) return null;
        const t = String(s).trim();
        const m = t.match(/^(\d{1,2})(?:[:.,\s]?(\d{2}))?$/);
        if (m) {
          const h = m[1].padStart(2, '0');
          const min = (m[2] || '00').padStart(2, '0');
          return `${h}:${min}`;
        }
        return null;
      };
      const toBoolTr = (v) => {
        if (typeof v === 'boolean') return v;
        if (v == null) return null;
        const s = String(v).trim().toLowerCase();
        if (['evet', 'true', '1', 'var', 'alındı'].includes(s)) return true;
        if (['hayir', 'hayır', 'false', '0', 'yok', 'alınmadı'].includes(s)) return false;
        return null;
      };
      const parseFee = (v) => {
        if (v == null) return null;
        const s = String(v).trim().replace(/[^\d.,-]/g, '');
        let normalized = s;
        const hasComma = s.includes(',');
        const hasDot = s.includes('.');
        if (hasComma && hasDot) {
          normalized = s.replace(/\./g, '').replace(/,/g, '.');
        } else if (hasComma && !hasDot) {
          normalized = s.replace(/,/g, '.');
        }
        const num = parseFloat(normalized);
        return isNaN(num) ? null : num;
      };

      const resolveTechId = async ({ id, name }) => {
        const idStr = id == null ? "" : String(id).trim();
        if (idStr && techById.has(idStr)) return Number(idStr);

        const nm = String(name || "").trim();
        if (!nm) return null;
        const key = nm.toLowerCase();
        const existing = techByName.get(key);
        if (existing) return existing;
        try {
          const created = await addTechnician(nm);
          const createdId = created?.id == null ? null : Number(created.id);
          if (createdId != null) {
            techByName.set(key, createdId);
            techById.set(String(createdId), created);
            return createdId;
          }
        } catch (_) { }
        return null;
      };

      const arr = Array.isArray(payload) ? payload : (Array.isArray(payload?.forms) ? payload.forms : []);
      for (const f of arr) {
        const technicianCandidate = {
          id: f.technician_id ?? f.technicianId ?? (f.technician && f.technician.id),
          name: f.technician_name ?? f.technicianName ?? (f.technician && f.technician.name),
        };
        const technician_id = await resolveTechId(technicianCandidate);

        const rawTeamIds = Array.isArray(f.team_ids ?? f.teamIds)
          ? (f.team_ids ?? f.teamIds)
          : (Array.isArray(f.team) ? f.team : []);

        const teamSet = new Set();
        for (const tm of rawTeamIds) {
          const tmCandidate = (tm && typeof tm === "object")
            ? { id: tm.id, name: tm.name }
            : { id: tm, name: "" };
          const resolved = await resolveTechId(tmCandidate);
          if (resolved == null) continue;
          if (technician_id != null && Number(resolved) === Number(technician_id)) continue;
          teamSet.add(Number(resolved));
        }
        const team_ids = Array.from(teamSet);

        const survey = f.survey && typeof f.survey === "object" && !Array.isArray(f.survey) ? f.survey : null;
        const p = {
          serial_number: f.serial_number ?? f.serialNumber ?? "",
          customer_name: f.customer_name ?? f.customerName ?? "",
          customer_phone: f.customer_phone ?? f.customerPhone ?? "",
          customer_email: f.customer_email ?? f.customerEmail ?? "",
          customer_address: f.customer_address ?? f.customerAddress ?? "",
          project_name: f.project_name ?? f.projectName ?? "",
          device_type: f.device_type ?? f.deviceType ?? "",
          device_serial: f.device_serial ?? f.deviceSerial ?? "",
          device_warranty: f.device_warranty ?? f.deviceWarranty ?? "",
          service_reason: f.service_reason ?? f.serviceReason ?? "",
          work_done: f.work_done ?? f.workDone ?? "",
          used_parts: f.used_parts ?? f.usedParts ?? "",
          service_fee: parseFee(f.service_fee ?? f.serviceFee),
          service_date: toISODate(f.service_date ?? f.serviceDate),
          service_start_time: toISOTime(f.service_start_time ?? f.serviceStartTime),
          service_end_time: toISOTime(f.service_end_time ?? f.serviceEndTime),
          follow_up_needed: toBoolTr(f.follow_up_needed ?? f.followUpNeeded) ?? false,
          delivered_working: toBoolTr(f.delivered_working ?? f.deliveredWorking) ?? true,
          payment_received: toBoolTr(f.payment_received ?? f.paymentReceived),
          payment_note: f.payment_note ?? f.paymentNote ?? "",
          operation_types: f.operation_types ?? f.operationTypes ?? {},
          technician_id,
          team_ids,
          survey,
        };
        try { await addForm(p); } catch (e) { /* continue */ }
      }
      await reload();
      toast({ title: "JSON içe aktarıldı", status: "success" });
    } catch (e) {
      toast({ title: "İçe aktarma hatası", description: String(e.message || e), status: "error" });
    }
  };

  const handleExportExcel = async () => {
    try {
      const data = items.map((f) => ({
        "Seri No": f.serial_number || "",
        "Müşteri": f.customer_name || "",
        "Telefon": f.customer_phone || "",
        "E-posta": f.customer_email || "",
        "Adres": f.customer_address || "",
        "Proje": f.project_name || "",
        "Cihaz Tipi": f.device_type || "",
        "Cihaz Seri": f.device_serial || "",
        "Garanti": f.device_warranty || "",
        "Servis Nedeni": f.service_reason || "",
        "Yapılan İşlem": f.work_done || "",
        "Kullanılan Parçalar": f.used_parts || "",
        "Servis Tutarı": f.service_fee ?? "",
        "Tarih": f.service_date || "",
        "Başlangıç": f.service_start_time || "",
        "Bitiş": f.service_end_time || "",
        "Teknisyen": (f.technician && f.technician.name) || "",
        "Takip Gerekli": (f.follow_up_needed ? "Evet" : "Hayır"),
        "Çalışır Teslim": (f.delivered_working ? "Evet" : "Hayır"),
        "Ödeme Alındı": (f.payment_received === true ? "Evet" : (f.payment_received === false ? "Hayır" : "")),
        "Ödeme Notu": f.payment_note || "",
        "Oluşturma": f.created_at ? new Date(f.created_at).toLocaleString() : "",
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Formlar");
      XLSX.writeFile(wb, `servis_formlari_${new Date().toISOString().split('T')[0]}.xlsx`);
      toast({ title: "Excel indirildi", status: "success" });
    } catch (e) {
      toast({ title: "Excel hatası", description: String(e.message || e), status: "error" });
    }
  };

  const hasSurvey = (row) => {
    const s = row?.survey || {};
    if (s && typeof s === "object" && String(s.status || "").toLowerCase() === "tamamlandi") return true;
    const vals = [s.q1, s.q2, s.q3, s.q4].filter(v => typeof v === "number" && v > 0);
    return vals.length > 0;
  };

  const getSurveyAvg = (row) => {
    const s = row?.survey || {};
    const vals = [s.q1, s.q2, s.q3, s.q4].filter(v => typeof v === "number" && v > 0);
    if (!vals.length) return null;
    return vals.reduce((a, b) => a + b, 0) / vals.length;
  };

  const filtered = items.filter(it => {
    const s = search.toLowerCase();
    const matchesText =
      (it.customer_name || "").toLowerCase().includes(s) ||
      (it.serial_number || "").toLowerCase().includes(s) ||
      ((it.technician && it.technician.name) || "").toLowerCase().includes(s);
    const created = it.created_at ? new Date(it.created_at) : null;
    const df = dateFrom ? new Date(dateFrom) : null;
    const dt = dateTo ? new Date(dateTo) : null;
    const inRange =
      (!df || (created && created >= df)) &&
      (!dt || (created && created <= new Date(dt.getTime() + 24 * 3600 * 1000)));
    const followOk =
      followFilter === "all" ||
      (followFilter === "yes" && !!it.follow_up_needed) ||
      (followFilter === "no" && !it.follow_up_needed);
    const deliveredOk =
      deliveredFilter === "all" ||
      (deliveredFilter === "yes" && !!it.delivered_working) ||
      (deliveredFilter === "no" && it.delivered_working === false);
    const techOk =
      techFilter === "all" || ((it.technician && it.technician.name) || "") === techFilter;
    const feeNum = Number(it.service_fee);
    const hasFee = !isNaN(feeNum) && feeNum > 0;
    const note = String(it.payment_note || "").toLowerCase();
    const paidHeuristic = (it.payment_received === true) || (it.payment_received == null && hasFee) || (note.includes("alındı") || note.includes("ödeme") || note.includes("odeme"));
    const payOk =
      payFilter === "all" ||
      (payFilter === "paid" && paidHeuristic) ||
      (payFilter === "unpaid" && !paidHeuristic);
    const opOk = opFilter === "all" || (it.operation_types && it.operation_types[opFilter]);
    const surveyDone = hasSurvey(it);
    const surveyOk =
      surveyFilter === "all" ||
      (surveyFilter === "done" && surveyDone) ||
      (surveyFilter === "none" && !surveyDone);
    return matchesText && inRange && followOk && deliveredOk && techOk && payOk && opOk && surveyOk;
  });

  const handleBulkSurvey = async () => {
    if (selectedItems.length === 0) {
      toast({ title: "Form seçilmedi", status: "warning" });
      return;
    }
    const rand = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);
    let count = 0;
    for (const row of selectedItems) {
      const survey = {
        q1: rand(ranges.q1[0], ranges.q1[1]),
        q2: rand(ranges.q2[0], ranges.q2[1]),
        q3: rand(ranges.q3[0], ranges.q3[1]),
        q4: rand(ranges.q4[0], ranges.q4[1]),
        status: "tamamlandi",
        note: "Toplu anket sonucu atandı",
      };
      try {
        await submitSurvey(row.id, survey);
        count++;
      } catch (_) { }
    }
    toast({ title: "Anket başarılı", description: `${count} form için anket sonuçları atandı`, status: "success" });
    onClose();
    reload();
  };

  const opTypes = [
    { value: "ARIZA_ONARIM", label: "Arıza Onarım" },
    { value: "URUN_DEGISIMI", label: "Ürün Değişimi" },
    { value: "EK_URUN_MONTAJI", label: "Ek Ürün Montajı" },
    { value: "CIHAZ_BAKIMI", label: "Cihaz Bakımı" },
    { value: "YEDEK_PARCA_SATISI", label: "Yedek Parça Satışı" },
    { value: "TESLIMAT", label: "Teslimat" },
    { value: "IADE", label: "İade" },
    { value: "DIGER", label: "Diğer" },
  ];

  const columns = [
    { title: "Seri No", dataIndex: "serial_number", sortable: true },
    { title: "Proje", dataIndex: "project_name", sortable: true },

    { title: "Müşteri", dataIndex: "customer_name", sortable: true },
    {
      title: "Teknisyenler",
      dataIndex: "technician",
      sortable: false,
      render: (_, row) => {
        const people = [];
        if (row.technician && row.technician.name) people.push({ ...row.technician, isMain: true });
        if (Array.isArray(row.team)) {
          for (const tm of row.team) {
            if (tm && tm.name) people.push({ ...tm, isMain: false });
          }
        }
        if (!people.length) return <Text color="gray.400" fontSize="xs">—</Text>;
        const topThree = people.slice(0, 3);
        const more = people.length - topThree.length;
        return (
          <HStack spacing={1}>
            <AvatarGroup size="sm" max={3}>
              {topThree.map((p) => (
                <Avatar
                  key={p.id || p.name}
                  name={p.name}
                  src={p.photo_url || undefined}
                  size="sm"
                />
              ))}
            </AvatarGroup>
            <Text fontSize="xs">
              {topThree.map(p => p.name).join(", ")}
              {more > 0 ? ` +${more}` : ""}
            </Text>
          </HStack>
        );
      },
    },
    {
      title: "Tarih",
      dataIndex: "service_date",
      sortable: true,
      render: (val) => (val ? new Date(val).toLocaleString() : "-"),
    },

    {
      title: "Ücret",
      dataIndex: "service_fee",
      sortable: true,
      render: (_, row) => {
        const received = row.payment_received;
        const fee = row.service_fee;
        if (received === false || !fee) {
          const note = row.payment_note ? String(row.payment_note) : "";
          const text = note ? `Alınmadı – ${note}` : "Alınmadı";
          return <Badge colorScheme="red">{text}</Badge>;
        }
        const num = Number(fee);
        if (!isNaN(num)) {
          try {
            return <Badge colorScheme="green">{new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(num)}</Badge>;
          } catch (_) {
            return String(fee);
          }
        }
        return String(fee);
      },
    },
    {
      title: "Anket",
      dataIndex: "survey",
      sortable: false,
      render: (_, row) => {
        const s = row.survey || {};
        const vals = [s.q1, s.q2, s.q3, s.q4].filter(v => typeof v === "number" && v > 0);
        if (!vals.length) {
          const st = String(s.status || "");
          if (st === "ulasilamadi") return <Badge variant="subtle" colorScheme="gray" borderRadius="full" px={2}>Ulaşılamadı</Badge>;
          if (st === "istemedi") return <Badge variant="subtle" colorScheme="gray" borderRadius="full" px={2}>İstemedi</Badge>;
          if (st === "numara_yok") return <Badge variant="subtle" colorScheme="gray" borderRadius="full" px={2}>No Yok</Badge>;
          return <Text color="gray.400" fontSize="xs">Yapılmadı</Text>;
        }
        const avg = vals.reduce((a, b) => a + b, 0) / vals.length;
        const color = avg >= 4 ? "green" : avg >= 3 ? "yellow" : "red";
        return (
          <Badge colorScheme={color} variant="solid" borderRadius="full" px={3} py={0.5}>
            {avg.toFixed(1)} / 5
          </Badge>
        );
      },
    },
  ];

  return (
    <VStack align="stretch" spacing={4}>
      <Box>
        <HStack justify="space-between" mb={2}>
          <Heading size="lg">Servis Formları</Heading>
        </HStack>
        <HStack spacing={6}>
          <Stat>
            <StatLabel>Toplam</StatLabel>
            <StatNumber>{items.length}</StatNumber>
            <StatHelpText>Tüm kayıtlar</StatHelpText>
          </Stat>
          <Stat>
            <StatLabel>Ödeme Alındı</StatLabel>
            <StatNumber>
              {items.filter(f => {
                const num = Number(f.service_fee);
                return (f.payment_received === true) || (f.payment_received == null && !isNaN(num) && num > 0);
              }).length}
            </StatNumber>
          </Stat>
          <Stat>
            <StatLabel>Takip Gerekli</StatLabel>
            <StatNumber color="orange.400">{items.filter(f => !!f.follow_up_needed).length}</StatNumber>
          </Stat>
        </HStack>
        <HStack spacing={3} wrap="wrap" bg="gray.50" p={4} borderRadius="xl" border="1px" borderColor="gray.100">
          <InputGroup maxW="260px">
            <InputLeftElement pointerEvents="none">
              <Icon as={FiPlus} opacity={0} />
            </InputLeftElement>
            <Input bg="white" placeholder="Ara (isim, seri no)" value={search} onChange={(e) => setSearch(e.target.value)} />
          </InputGroup>
          <Input bg="white" type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
          <Input bg="white" type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
          <Select bg="white" value={followFilter} onChange={(e) => setFollowFilter(e.target.value)} maxW="180px">
            <option value="all">Takip: Hepsi</option>
            <option value="yes">Takip Gerekli</option>
            <option value="no">Takip Gerekli Değil</option>
          </Select>
          <Select bg="white" value={deliveredFilter} onChange={(e) => setDeliveredFilter(e.target.value)} maxW="200px">
            <option value="all">Teslim: Hepsi</option>
            <option value="yes">Çalışır Teslim</option>
            <option value="no">Çalışır Değil</option>
          </Select>
          <Select bg="white" value={techFilter} onChange={(e) => setTechFilter(e.target.value)} maxW="220px">
            <option value="all">Teknisyen: Hepsi</option>
            {techs.map((t) => (
              <option key={t.id} value={t.name}>{t.name}</option>
            ))}
          </Select>
          <Select bg="white" value={opFilter} onChange={(e) => setOpFilter(e.target.value)} maxW="220px">
            <option value="all">İşlem Tipi: Hepsi</option>
            {opTypes.map((t) => (
              <option key={t.value} value={t.value}>{t.label}</option>
            ))}
          </Select>
          <Select bg="white" value={surveyFilter} onChange={(e) => setSurveyFilter(e.target.value)} maxW="220px">
            <option value="all">Anket: Hepsi</option>
            <option value="done">Anket Yapılanlar</option>
            <option value="none">Anket Yapılmayanlar</option>
          </Select>
          <Button onClick={() => window.location.assign("/formlar/yeni")} colorScheme="blue" px={8}>Yeni Form</Button>
          {selectedItems.length > 0 && (
            <Button leftIcon={<FiCheckSquare />} colorScheme="green" variant="solid" shadow="sm" onClick={onOpen}>
              Toplu Anket ({selectedItems.length})
            </Button>
          )}
        </HStack>
        <HStack spacing={3} wrap="wrap" mt={3} justify="flex-end">
          <Button variant="outline" size="sm" onClick={handleExportExcel}>Excel İndir</Button>
          <Button variant="outline" size="sm" onClick={handleExportJson}>DB Dışa Aktar</Button>
          <Button variant="outline" size="sm" onClick={() => document.getElementById("forms-import-json").click()}>DB İçe Aktar</Button>
          <input id="forms-import-json" type="file" accept="application/json" style={{ display: "none" }} onChange={(e) => handleImportJson(e.target.files?.[0])} />
          <Button variant="outline" size="sm" colorScheme="red" onClick={async () => {
            if (!window.confirm("Tüm form kayıtları silinecek. Emin misiniz?")) return;
            await clearForms();
            await reload();
            toast({ title: "Tüm formlar silindi", status: "info" });
          }}>Tüm Formları Sil</Button>
        </HStack>
      </Box>
      <ModernTable
        data={filtered}
        columns={columns}
        variant="default"
        size="md"
        searchable={false}
        filterable={false}
        selectable={true}
        getRowProps={(row) => {
          const avg = getSurveyAvg(row);
          if (avg != null && avg < 3) {
            return {
              bg: "red.50",
              boxShadow: "inset 4px 0 0 #E53E3E",
              _hover: { bg: "red.50", transform: "none" },
            };
          }
          return {};
        }}
        onSelectionChange={(rows) => setSelectedItems(rows)}
        actions={[
          {
            ...TABLE_ACTIONS.view,
            label: "Detay",
            onClick: (row) => navigate(`/formlar/${row.id}`),
          },
          {
            ...TABLE_ACTIONS.edit,
            label: "Yeni Tasarım",
            onClick: (row) => navigate(`/formlar/${row.id}/duzenle`),
          },
          {
            ...TABLE_ACTIONS.delete,
            onClick: (row) => handleDelete(row.id),
          },
        ]}
        onRowClick={(row) => navigate(`/formlar/${row.id}`)}
        emptyMessage="Kayıt yok"
      />

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Toplu Anket Sonucu Atama</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={6} align="stretch">
              <Text fontSize="sm" color="gray.600">
                Seçili {selectedItems.length} adet form için aşağıdaki kriterlerde rastgele puanlama yapılacaktır.
              </Text>

              <FormControl>
                <FormLabel>Hizmet Memnuniyeti (Puan Aralığı: {ranges.q1[0]}-{ranges.q1[1]})</FormLabel>
                <RangeSlider min={1} max={5} step={1} value={ranges.q1} onChange={(v) => setRanges({ ...ranges, q1: v })}>
                  <RangeSliderTrack><RangeSliderFilledTrack /></RangeSliderTrack>
                  <RangeSliderThumb index={0} /><RangeSliderThumb index={1} />
                </RangeSlider>
              </FormControl>

              <FormControl>
                <FormLabel>Teknisyen İletişimi (Puan Aralığı: {ranges.q2[0]}-{ranges.q2[1]})</FormLabel>
                <RangeSlider min={1} max={5} step={1} value={ranges.q2} onChange={(v) => setRanges({ ...ranges, q2: v })}>
                  <RangeSliderTrack><RangeSliderFilledTrack /></RangeSliderTrack>
                  <RangeSliderThumb index={0} /><RangeSliderThumb index={1} />
                </RangeSlider>
              </FormControl>

              <FormControl>
                <FormLabel>Zamanında Gelme (Puan Aralığı: {ranges.q3[0]}-{ranges.q3[1]})</FormLabel>
                <RangeSlider min={1} max={5} step={1} value={ranges.q3} onChange={(v) => setRanges({ ...ranges, q3: v })}>
                  <RangeSliderTrack><RangeSliderFilledTrack /></RangeSliderTrack>
                  <RangeSliderThumb index={0} /><RangeSliderThumb index={1} />
                </RangeSlider>
              </FormControl>

              <FormControl>
                <FormLabel>Çözüm Yeterliliği (Puan Aralığı: {ranges.q4[0]}-{ranges.q4[1]})</FormLabel>
                <RangeSlider min={1} max={5} step={1} value={ranges.q4} onChange={(v) => setRanges({ ...ranges, q4: v })}>
                  <RangeSliderTrack><RangeSliderFilledTrack /></RangeSliderTrack>
                  <RangeSliderThumb index={0} /><RangeSliderThumb index={1} />
                </RangeSlider>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>İptal</Button>
            <Button colorScheme="green" onClick={handleBulkSurvey}>Anketleri Tanımla</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </VStack>
  );
}
